<template>
  <div class="campaign-card-body-summary-amount">
    <span class="campaign-card-body-summary-amount__current-value">{{
      currentValueText
    }}</span>
    <span class="campaign-card-body-summary-amount__goal"
      >目標:{{ targetValueText }}</span
    >
  </div>
</template>

<script>
import NumberHelper from '@/number-helper';

export default {
  name: 'CampaignCardBodyAmount',
  props: {
    isTargetDonor: {
      type: Boolean,
      required: true,
    },
    currentValue: {
      type: Number,
      required: true,
    },
    goal: {
      type: Number,
      required: true,
    },
  },
  computed: {
    _suffixUnit() {
      return this.isTargetDonor ? '人' : '円';
    },
    currentValueText() {
      const currentValueWithComma = NumberHelper.format(this.currentValue);
      return `${currentValueWithComma}${this._suffixUnit}`;
    },
    targetValueText() {
      const targetValueWithComma = NumberHelper.format(this.goal);
      return `${targetValueWithComma}${this._suffixUnit}`;
    },
  },
};
</script>

<style scoped lang="scss">
.campaign-card-body-summary-amount {
  display: flex;
  align-items: flex-end;
}

.campaign-card-body-summary-amount__current-value {
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
}

.campaign-card-body-summary-amount__goal {
  margin-left: 8px;

  font-size: 12px;
  line-height: 18px;
  color: $c-black-note;
}
</style>
